<template>
  <div class="floor9-wrapper">
    <div class="content">
      <div class="title"></div>
      <a class="join" href="https://h5.gegejia.com/adminSettle/#/home" target="_blank"></a>
      <div class="btns">
        <div class="btn flow" @click="handleClickFlow"></div>
        <div class="btn desc" @click="handleClickDesc"></div>
        <div class="btn problem" @click="handleClickPro"></div>
      </div>
      <div class="foot"></div>
    </div>

    <div class="modal" v-if="modalVisible" @mousewheel.stop>
      <div class="cont">
        <img class="picture" src="~images/floor9/modal_flow.png" v-if="modalCont===1">
        <img class="picture" src="~images/floor9/modal_desc.png" v-else-if="modalCont===2">
        <img class="picture" src="~images/floor9/modal_pro.png" v-else>
      </div>
      <img class="close" src="~images/floor9/close.png" @click="handleClose">
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      modalVisible: false,
      modalCont: ""
    };
  },
  methods: {
    handleClose() {
      this.modalVisible = false;
    },
    handleClickFlow() {
      this.modalVisible = true;
      this.modalCont = 1;
    },
    handleClickDesc() {
      this.modalVisible = true;
      this.modalCont = 2;
    },
    handleClickPro() {
      this.modalVisible = true;
      this.modalCont = 3;
    }
  }
};
</script>

<style scoped lang="less">
.floor9-wrapper {
  position: relative;
  width: 100%;
  height: 100%;
  background-image: url(~images/floor9/bg.png);
  background-repeat: no-repeat;
  background-size: cover;
  .content {
    padding-left: 106px;
    padding-right: 102px;
    width: auto;
  }
  .title {
    display: inline-block;
    width: 552px;
    height: 103px;
    margin-top: 25vh;
    background-image: url(~images/floor9/title.png);
    background-repeat: no-repeat;
    background-size: cover;
  }
  .join {
    float: right;
    width: 320px;
    height: 119px;
    margin-top: 25vh;
    background-image: url(~images/floor9/join_btn.png);
    background-repeat: no-repeat;
    background-size: cover;
    cursor: pointer;
  }
  .join:active {
    background-image: url(~images/floor9/join_btn_sel.png);
  }
  .btns {
    display: flex;
    justify-content: space-between;
    margin-top: 11vh;
  }
  .btn {
    display: inline-block;
    width: 306px;
    height: 103px;
    background-repeat: no-repeat;
    background-size: cover;
    cursor: pointer;
  }
  .flow {
    background-image: url(~images/floor9/flow_btn.png);
  }
  .desc {
    background-image: url(~images/floor9/desc_btn.png);
  }
  .problem {
    background-image: url(~images/floor9/pro_btn.png);
  }
  .foot {
    width: 100%;
    height: 102px;
    margin-top: 8vh;
    background-image: url(~images/floor9/desc.png);
    background-repeat: no-repeat;
    background-size: cover;
  }
  .modal {
    box-sizing: border-box;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    padding: 136px 72px 158px 72px;
    .cont {
      // position: relative;
      width: 100%;
      height: 100%;
      overflow-y: auto;
      .picture {
        width: 100%;
      }
    }
    .close {
      position: absolute;
      top: 151px;
      right: 87px;
      width: 20px;
      height: 20px;
      cursor: pointer;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/floor/floor_9.vue